<template>
    <div>
        <div class="text-h6 font-weight-regular mb-2">
            <slot></slot>
        </div>
        <v-divider></v-divider>
    </div>
</template>

<script>
export default {
    name: "Headline"
}
</script>

<style scoped>

.v-divider {
    margin-bottom: 15px;
}
</style>